import { BrowserRouter as Router } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { AuthProvider } from './contexts/AuthContext'
import { ToastProvider } from './contexts/ToastContext'
import { ServiceWorkerProvider } from './contexts/ServiceWorkerContext'
import { ConversationListProvider } from './contexts/ConversationListContext'
import { AppRoutes } from './routes/AppRoutes'
import ErrorBoundary from './components/common/ErrorBoundary'
import { Clarity } from './components/analytics/Clarity'
import { OfflineIndicator } from './components/ui/OfflineIndicator'
import { UpdatePrompt } from './components/ui/UpdatePrompt'
import { ConditionalConsoleExporter } from './components/ui/ConditionalConsoleExporter'
import './styles/App.css'

function App() {
  return (
    <ErrorBoundary>
      <HelmetProvider>
        <ServiceWorkerProvider>
          <ToastProvider>
            <AuthProvider>
              <ConversationListProvider>
                <Router>
                  <Clarity />
                  <OfflineIndicator />
                  <UpdatePrompt />
                  <ConditionalConsoleExporter position="bottom-right" showStats={true} />
                  <AppRoutes />
                </Router>
              </ConversationListProvider>
            </AuthProvider>
          </ToastProvider>
        </ServiceWorkerProvider>
      </HelmetProvider>
    </ErrorBoundary>
  )
}

export default App
